import { Model, Field, UseGetQuery, UseUpdateMutation } from 'types/model'
import { useUpdate } from './useUpdate'
import { useUpdateFieldSimple } from './useUpdateFieldSimple'

/*
Description:
  The purpose of the useUpdateField hook is to create per-field update capabilities
  based on a timeout. The hook handles data fetching for the component.

Parameters:
  id: id of entity
  field: field name of entity to observe and update
  queryName: query name, used to extract contents of useGetModelQuery
  useGetQuery: autogenerated query hook for the model  
  __typename: __typename of model
  fragmentDoc: auto-generated fragment doc for model
  mutationName: mutation name
  useUpdateMutation: auto-generated useUpdateMutation for model
  timeout?: timeout used to debounce updates
 */

type UseUpdateFieldParams<M extends Model, F extends Field<M>> = {
  id: string
  __typename: string
  fragmentDoc: any
  field: F
  useGetQuery: UseGetQuery<M>
  queryName: string
  useUpdateMutation: UseUpdateMutation<M>
  mutationName: string
  timeout?: number
}

export function useUpdateField<M extends Model, F extends Field<M>>(
  params: UseUpdateFieldParams<M, F>,
) {
  const update = useUpdate(params)
  return useUpdateFieldSimple({
    ...params,
    update,
  })
}

/*
Description:
  The purpose of the createUpdateFieldHook is to create multiple instances of useUpdateField
  where only field and id is changed

Parameters:
  Same as useUpdateField, without field and id
*/

type CreateUpdateFieldHookParams<M extends Model> = {
  __typename: string
  fragmentDoc: any
  useGetQuery: UseGetQuery<M>
  queryName: string
  useUpdateMutation: UseUpdateMutation<M>
  mutationName: string
  timeout?: number
}

export function createUpdateFieldHook<M extends Model>(
  params: CreateUpdateFieldHookParams<M>,
) {
  return function useUpdateFieldGenerated<F extends Field<M>>({
    id,
    field,
    timeout,
  }: {
    id: string
    timeout?: number
    field: F
  }) {
    return useUpdateField({ ...params, timeout, id, field })
  }
}
